// extracted by mini-css-extract-plugin
export default {"titleStyle":"templateHeader_titleStyle__8Es97","titleStyleWrapper":"templateHeader_titleStyleWrapper__INOx9","stepStatus":"templateHeader_stepStatus__8m-JI"};